module.exports = __webpack_public_path__ + "static/media/pml.f06264c8.webp";